<!-- Provider-state hero + consequence (RF-22) — deliberately NO send-behavior control here -->
<div class="alert" [ngClass]="heroAlertClass()" role="alert">
  <h5 class="alert-heading mt-0 mb-1">{{ heroTitle() }}</h5>
  <p class="mb-0">{{ heroConsequence() }}</p>
</div>

<!-- Open pending issues (RF-23): most severe first; external links only -->
<div class="card">
  <div class="card-body">
    <h5 class="section-title">{{ 'channel.health.status.pendingTitle' | translate }}</h5>
    @if (pendingIssues.length === 0) {
      <p class="text-muted mb-0">{{ 'channel.health.pending.none' | translate }}</p>
    } @else {
      @for (issue of pendingIssues; track issue.code) {
        <div class="alert alert-warning d-flex flex-wrap align-items-center gap-2 py-2 mb-2" role="alert">
          <span class="badge campaign-badge is-neutral">{{ issueCategory(issue) }}</span>
          <span class="flex-grow-1">{{ issueTitle(issue) }}</span>
          @if (issue.link) {
            <a class="alert-link text-nowrap" [href]="issue.link" target="_blank" rel="noopener">
              {{ 'channel.health.status.pendingOpenExternal' | translate }}
              <i class="mdi mdi-open-in-new"></i>
            </a>
          }
        </div>
      }
    }
  </div>
</div>

<!-- Per-entity diagnosis (RF-25) -->
<div class="card">
  <div class="card-body">
    <h5 class="section-title">{{ 'channel.health.status.entitiesTitle' | translate }}</h5>
    @if (!health?.entities?.length) {
      <p class="text-muted mb-0">{{ 'channel.health.status.entitiesEmpty' | translate }}</p>
    } @else {
      @for (entity of health?.entities ?? []; track $index) {
        <div class="alert py-2 mb-2" [ngClass]="entityAlertClass(entity.canSendMessage)" role="alert">
          <strong>{{ entityLabel(entity.type) }}</strong> · {{ entityStateLabel(entity.canSendMessage) }}
          @if (entity.reason) {
            <p class="mb-0 small">{{ entityReason(entity) }}</p>
          }
        </div>
      }
    }
  </div>
</div>

<!-- Signal cards (RF-26) -->
<div class="card">
  <div class="card-body">
    <h5 class="section-title">{{ 'channel.health.status.signalsTitle' | translate }}</h5>
    <div class="signal-grid">
      @for (signal of signalCards(); track signal.key) {
        <div class="signal-grid__row">
          <span class="text-muted">{{ ('channel.health.signal.' + signal.key) | translate }}</span>
          @if (signal.tone === 'warn' || signal.tone === 'bad') {
            <span class="badge campaign-badge signal-grid__value" [ngClass]="signal.tone === 'bad' ? 'is-err' : 'is-warn'">{{ signal.value }}</span>
          } @else {
            <span class="fw-semibold signal-grid__value">{{ signal.value }}</span>
          }
        </div>
      }
    </div>
  </div>
</div>

<!-- Event history (RF-24) — webhooks + reading diffs, 90-day retention -->
<div class="card">
  <div class="card-body">
    <h5 class="section-title">{{ 'channel.health.status.eventsTitle' | translate }}</h5>
    <p class="text-muted small">{{ 'channel.health.status.eventsSubtitle' | translate }}</p>
    @if (allEvents.length === 0) {
      <p class="text-muted mb-0">{{ 'channel.health.status.eventsEmpty' | translate }}</p>
    } @else {
      <ul class="event-list">
        @for (event of allEvents; track event._id) {
          <li class="event-list__item">
            <span class="event-dot" [ngClass]="severityClass(event)"></span>
            <i class="mdi event-list__icon" [ngClass]="kindIcon(event)"></i>
            <div class="event-list__content">
              <span class="event-list__title">{{ event.title }}</span>
              @if (event.detail) {
                <span class="event-list__detail">{{ event.detail }}</span>
              }
            </div>
            <span class="event-list__when">{{ event.createdAt | date: 'dd/MM/yyyy HH:mm' }}</span>
          </li>
        }
      </ul>
      @if (hasMoreEvents) {
        <button type="button" class="btn btn-sm btn-outline-secondary" (click)="loadMoreEvents()" [disabled]="loadingEvents">
          {{ 'channel.health.status.eventsLoadMore' | translate }}
        </button>
      }
    }
  </div>
</div>
